import React, { useContext } from 'react';
import useTranslation from 'next-translate/useTranslation';
import PropTypes from 'prop-types';

// Context
import ApproachContext from '../../../../context/ApproachContext';

// Styles
import styles from './footer.module.scss';

const Footer = ({ lang }) => {
  const approach = useContext(ApproachContext);
  const { t } = useTranslation('common');

  return (
    <footer id="footer" className={styles.container}>
      <div className={styles.poweredBy}>
        <p className={styles.content}>
          {t(`description_page.powered_by.${approach}`)}{' '}
          {/* eslint-disable-next-line react/jsx-no-target-blank */}
          <a
            href={
              lang === 'de'
                ? 'https://www.lionstep.com/de/kandidaten/'
                : 'https://www.lionstep.com/candidates/'
            }
            rel="noopener"
            target="_blank"
            aria-label="Lionstep candidate page"
            data-testid="logo-link-footer"
          >
            <img
              src="/static/lionstep-logo.svg"
              alt="Lionstep"
              className={styles.logo}
            />
          </a>
        </p>
      </div>
    </footer>
  );
};

Footer.propTypes = {
  lang: PropTypes.string.isRequired,
};

export default Footer;
